import inf1 from '../../../../assets/img/movil/infraestructura.jpg';
import inf2 from '../../../../assets/img/movil/infraestructura2.jpg';
import './CMInfraestructura.css';

function CMInfraestructura() {

    return (
        <div id="CMInfraestructura">
            <section id="Inf__head">
                <h2>Soluciones de Infraestructura</h2>
                <ul>
                    <li>Inicio</li>
                    <li>/</li>
                    <li>Servicios</li>
                    <li>/</li>
                    <li>Soluciones de Infraestructura</li>
                </ul>
            </section>
            <section id="Inf__section2">
                <figure id="Inf-content">
                    <img src={inf1} />
                </figure>
                <div id="Inf-text">
                    <p id="Inf-text__p1">Damos respuesta a las necesidades de la <strong>plataforma de Tecnologías de la Información</strong> de las empresas.</p>
                    <p id="Inf-text__p2">Una gestión inadecuada de la tecnología puede impactar negativamente en cada área de la organización. Por ello, es indispensable contar con una infraestructura segura, eficiente y confiable, donde la alta disponibilidad, la seguridad de la información y la capacidad operativa sean requisitos no negociables.</p>
                </div>
            </section>
            <section id="Inf__section3">
                <div id="Infs3-content1">
                    <div id="Inf3-content1__text">
                        <p id="Inf3-content1__text--p1">A través de nuestro modelo de entrega, <strong>INFRASOL</strong> brinda servicios rentables basados en Acuerdos de Nivel de Servicio (SLAs), respaldados por una metodología madura alineada a las mejores prácticas ITIL y un sólido programa de calidad.</p>
                        <p id="Inf3-content1__text--p2">Contamos con amplia experiencia en la planificación, diseño, implementación y gestión de proyectos de soluciones informáticas, integrando tecnología y servicios para responder a los requerimientos técnicos y estratégicos de nuestros clientes.</p>
                        <p id="Inf3-content1__text--p3">Disponemos de la experiencia, conocimientos y capacidades necesarias para implementar Hardware, Software y Comunicaciones, alineándolos con la estrategia de negocio de cada organización.</p>
                        <p id="Inf3-content1__text--p4">Nuestro enfoque se estructura en tres fases fundamentales: Diseño, Operación e Implementación.</p>
                    </div>
                    <div id="Inf3-content1__image">
                        <figure>
                            <img src={inf2} />
                        </figure>
                    </div>
                </div>
                <div id="Infs3-content2">
                    <div id="Infs3-content2__text1">
                        <div id="Infs3-content2__text1--i1">
                            <h3>F1 - Diseño</h3>
                            <div></div>
                            <p>Diseño, implementación y administración de plataformas Microsoft: System Center, Hyper-V, Exchange Server, SharePoint Server, Lync Server, SQL Server y TMG Server. Servicios de networking y control de accesos.</p>
                        </div>
                        <div id="Infs3-content2__text1--i2">
                            <h3>F2 - Operación</h3>
                            <div></div>
                            <p>Gestión documental, outsourcing de impresión y sistemas de mensajería unificada: correo electrónico, videoconferencia y telefonía IP.</p>
                        </div>
                    </div>
                    <div id="Infs3-content2__text2">
                        <h3 id="Infs3-content2__text2--i3">F3 - Implementación</h3>
                        <div></div>
                        <ul>
                            <li>Servidores proxy, archivos, impresión y seguridad; antivirus y firewalls; VLANs, accesos remotos y conexiones VPN LAN to LAN.</li>
                            <li>Soluciones de alta disponibilidad: balanceo de carga.</li>
                            <li>Replicación de servidores: Network Load Balancing y Failover.</li>
                            <li>Instalación y administración de sistemas operativos y bases de datos; gestión de inventarios de hardware y software; control de licenciamiento y mesas de ayuda.</li>
                            <li>Instalación y retiro de UPS y baterías de marcas líderes: APC, Forza, Ritar, entre otras.</li>
                            <li>Soluciones de almacenamiento: Fiber Channel, iSCSI, SAS y Ethernet; discos SAS, SATA y estado sólido.</li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default CMInfraestructura;